import { 
  buildOAuthUrl, 
  createOAuthPopup, 
  generatePKCEPair, 
  parseCodeFromQuery as parseCode, 
} from "./oauth-pkce-helper";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const REDIRECT_URI = `${window.location.origin}/google/callback`;

export const signInWithGooglePopup = async () => {
  const { codeVerifier, codeChallenge } = await generatePKCEPair();

  const authUrl = buildOAuthUrl("https://accounts.google.com/o/oauth2/v2/auth", {
    client_id: GOOGLE_CLIENT_ID,
    response_type: "code",
    redirect_uri: REDIRECT_URI,
    scope: "openid profile email",
    prompt: "select_account",
    code_challenge: codeChallenge,
    code_challenge_method: "S256",
  });

  return createOAuthPopup({
    authUrl,
    popupTitle: "Google Sign In",
    successMessageType: "GOOGLE_AUTH_SUCCESS",
    errorMessageType: "GOOGLE_AUTH_ERROR",
    providerName: "Google",
    codeVerifier,
  });
};

export const parseCodeFromQuery = () => parseCode("Google");

